import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import es from './locales/es.json';
import en from './locales/en.json';
import {
  IDIOMAS, IDIOMA_POR_DEFECTO, CLAVE_ALMACENAMIENTO,
  resolverIdioma, normalizarIdioma,
} from './idiomas';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    lng: resolverIdioma(),
    fallbackLng: IDIOMA_POR_DEFECTO,
    supportedLngs: IDIOMAS.map((idioma) => idioma.codigo),
    interpolation: {
      // React ya escapa lo que pinta: escapar aquí duplicaría entidades
      escapeValue: false,
    },
    returnEmptyString: false,
  });

/** Mantiene sincronizados el <html lang> y el idioma activo. */
const marcarIdiomaEnDocumento = (idioma) => {
  document.documentElement.setAttribute('lang', idioma);
};

marcarIdiomaEnDocumento(i18n.language);
i18n.on('languageChanged', marcarIdiomaEnDocumento);

/**
 * Cambia el idioma de la interfaz y lo recuerda en el navegador. La
 * preferencia de la cuenta se guarda aparte (perfil → servidor), esto es lo
 * que hace que un invitado conserve su elección entre visitas.
 */
export const cambiarIdioma = (codigo) => {
  const idioma = normalizarIdioma(codigo) || IDIOMA_POR_DEFECTO;
  try {
    localStorage.setItem(CLAVE_ALMACENAMIENTO, idioma);
  } catch (err) {
    // Navegación privada o almacenamiento bloqueado: el cambio sigue valiendo
    // para esta sesión aunque no se pueda recordar.
  }
  return i18n.changeLanguage(idioma);
};

/**
 * Re-evalúa el idioma cuando cambia la sesión (login, logout o guardado del
 * perfil): así el idioma de la cuenta entra en vigor sin recargar la página.
 */
export const sincronizarIdiomaConSesion = () => {
  const idioma = resolverIdioma();
  if (idioma !== i18n.language) i18n.changeLanguage(idioma);
  return idioma;
};

window.addEventListener('auth-token-changed', sincronizarIdiomaConSesion);

export default i18n;
